module.exports = [{"data":"consignment","title":"consignment"},{"data":"volume","title":"volume"},{"data":"inj","title":"inj"},{"data":"alphaT","title":"alphaT"},{"data":"alphaT3","title":"alphaT3"},{"data":"gtbt3","title":"β-tocotrienol/ γ-tocopherol"},{"data":"gtb","title":"γ-tocotrienol"},{"data":"dt","title":"δ-tocopherol"},{"data":"dt3","title":"δ-tocotrienol"},{"data":"total","title":"Total"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/vitamin-raw-variable.json
// module id = qaF+
// module chunks = 102